import { render, staticRenderFns } from "./ListOfGroupsOfType.vue?vue&type=template&id=187ada2b&"
import script from "./ListOfGroupsOfType.vue?vue&type=script&lang=js&"
export * from "./ListOfGroupsOfType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports